import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'




const MultiProfileConfirmPopUp = ({ text, functions }) => {

    const { title = null, description = null, positiveButtonText = null,
        negativeButtonText = null, singleButtonText = null, } = text

    const { positiveButtonFunction = null, negativeButtonFunction = null, singleButtonFunction } = functions
    const { profileManagementThemes = {} } = useSelector(store => store.profileManagement)
    const [theme, setTheme] = useState(null)



    // --Setting Profile Theme---
    useEffect(() => {
        setTheme(profileManagementThemes.themeProfilePopup)
    }, [profileManagementThemes])

    return (
        <MultiProfileConfirmPopUpStyled theme={theme} >
            <div className="MultiProfileConfirmPopUpStyled-whole-page">
                <div className="MultiProfileConfirmPopUpStyled-wrapper">

                    <div className="MultiProfileConfirmPopUpStyled-wrapper_header">
                        {title && <div className="MultiProfileConfirmPopUpStyled-wrapper_header__title">
                            {title}
                        </div>}
                        {description && <div className="MultiProfileConfirmPopUpStyled-wrapper_header__description">
                            {description}
                        </div>}

                    </div>
                    <div className="MultiProfileConfirmPopUpStyled-wrapper__buttons">
                        {positiveButtonText && <div className="MultiProfileConfirmPopUpStyled-wrapper__buttons__positive_button" onClick={positiveButtonFunction}>
                            {positiveButtonText}
                        </div>}
                        {negativeButtonText && <div className="MultiProfileConfirmPopUpStyled-wrapper__buttons__negative_button" onClick={negativeButtonFunction}>
                            {negativeButtonText}
                        </div>}
                        {singleButtonText && <div className="MultiProfileConfirmPopUpStyled-wrapper__buttons__single-button" onClick={singleButtonFunction} >
                            {singleButtonText}
                        </div>}
                    </div>
                </div>
            </div>

        </MultiProfileConfirmPopUpStyled>

    )
}


const MultiProfileConfirmPopUpStyled = styled.div`
.MultiProfileConfirmPopUpStyled-whole-page{
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: #00000080;
    z-index: 13;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;


    .MultiProfileConfirmPopUpStyled-wrapper{
        width: 342px;
        // height: 185px;
        border-radius: 5px;
        background-color: ${({theme: { body } }) => body && body.background && body.background.primary };
        padding: 30px 20px;

        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
       

       
        
        .MultiProfileConfirmPopUpStyled-wrapper_header{
            .MultiProfileConfirmPopUpStyled-wrapper_header__title{
                font-size: 22px;
                color: ${({theme: {header} }) => header && header.text && header.text.primary };
                font-weight: bold;
                text-align: center;
            }//MultiProfileConfirmPopUpStyled-wrapper_header__title
            .MultiProfileConfirmPopUpStyled-wrapper_header__description{
                font-size: 14px;
                color: ${({theme: {body} }) => body && body.text && body.text.primary };
                font-weight: normal;
                margin-top: 10px;
                text-align: center;
            }//MultiProfileConfirmPopUpStyled-wrapper_header__description
        }//MultiProfileConfirmPopUpStyled-wrapper_header

        .MultiProfileConfirmPopUpStyled-wrapper__buttons{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 15px;

            .MultiProfileConfirmPopUpStyled-wrapper__buttons__positive_button{
                width: 139px;
                height: 46px;

                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                font-size: 16px;
                font-weight: bold;
                color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.normal.text };
                background-color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.normal.background };
                border-radius: 5px;

                :hover{
                    color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.focussed.text };
                    background-color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.focussed.background };

                }


            }//MultiProfileConfirmPopUpStyled-wrapper__buttons__positive_button
            .MultiProfileConfirmPopUpStyled-wrapper__buttons__negative_button{
                width: 139px;
                height: 46px;

                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                font-size: 16px;
                font-weight: bold;
                color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.normal && compositeStyle.secondaryButton.normal.text };
                background-color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.normal && compositeStyle.secondaryButton.normal.background };
                border: solid 1px ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.normal && compositeStyle.secondaryButton.normal.stroke };
                border-radius: 5px;

                :hover{
                    color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.focussed && compositeStyle.secondaryButton.focussed.text };
                    background-color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.focussed && compositeStyle.secondaryButton.focussed.background };
                    border: solid 1px ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.focussed && compositeStyle.secondaryButton.focussed.stroke };;
                }

            }//MultiProfileConfirmPopUpStyled-wrapper__buttons__negative_button

            .MultiProfileConfirmPopUpStyled-wrapper__buttons__single-button{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                height: 46px;
                width: 100%;

                font-size: 16px;
                font-weight: bold;

                border-radius: 5px;

                color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.normal.text };
                background-color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.normal.background };

                :hover{
                    color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.focussed.text };
                    background-color: ${({theme: {compositeStyle} }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.focussed.background };

                }

            }//MultiProfileConfirmPopUpStyled-wrapper__buttons__single-button

        }//MultiProfileConfirmPopUpStyled-wrapper__buttons

    }//MultiProfileConfirmPopUpStyled-wrapper
}//MultiProfileConfirmPopUpStyled-whole-page
`

export default MultiProfileConfirmPopUp